import React from 'react'

const CurrencySymbol = ({ currency }) => {
    // 根据currency的值显示不同的货币符号
    let currencySymbol = ''
    switch (currency) {
        case 'CNY':
            currencySymbol = '¥'
            break
        case 'USD':
            currencySymbol = '$'
            break
        case 'EUR':
            currencySymbol = '€'
            break
        case 'GBP':
            currencySymbol = '£'
            break
        case 'JPY':
            currencySymbol = '¥'
            break
        case 'KRW':
            currencySymbol = '₩'
            break
        case 'HKD':
            currencySymbol = 'HK$'
            break
        case 'TWD':
            currencySymbol = 'NT$'
            break
        case 'CHF':
            currencySymbol = 'Fr.'
            break
        case 'AUD':
            currencySymbol = 'A$'
            break
        case 'CAD':
            currencySymbol = 'C$'
            break
        case 'SGD':
            currencySymbol = 'S$'
            break
        case 'THB':
            currencySymbol = '฿'
            break
        case 'INR':
            currencySymbol = '₹'
            break
        case 'RUB':
            currencySymbol = '₽'
            break
        case 'VND':
            currencySymbol = '₫'
            break
        default:
            currencySymbol = currency // 如果没有匹配的货币符号，显示货币代码
    }
    return (
        <span>
            {currencySymbol}
        </span>
    )
}

export default CurrencySymbol